import React from 'react';
import './About.css';
import ME from '../../assets/img-1.jpeg';
import { FaAppStore } from 'react-icons/fa';
import { HiOutlineSparkles } from 'react-icons/hi';
import { TbBrandApple } from 'react-icons/tb';
import { LuGraduationCap } from 'react-icons/lu';

const About = () => {
  return (
    <section id="about">
      <h5>About me</h5>
      <h2>Who I am</h2>

      <div className='container about__container'>
        <div className='about__me'>
          <div className='about__me-image'>
            <img
              src={ME}
              alt="Felipe Alberto"
              width="768"
              height="1024"
              loading="lazy"
              decoding="async"
            />
          </div>
        </div>

        <div className='about__content'>
          <div className='about__cards'>
            <article className='about__card'>
              <FaAppStore className='about__icon' />
              <h3>3 Apps</h3>
              <h5>Published on App Store</h5>
            </article>

            <article className='about__card'>
              <HiOutlineSparkles className='about__icon' />
              <h3>GenAI</h3>
              <h5>Agents, SDD, Harness &amp; multimodal POCs</h5>
            </article>

            <article className='about__card'>
              <TbBrandApple className='about__icon' />
              <h3>Apple Developer Academy</h3>
              <h5>Instituto de Pesquisas Eldorado</h5>
            </article>

            <article className='about__card'>
              <LuGraduationCap className='about__icon' />
              <h3>FIAP</h3>
              <h5>Software Engineering, 2023 to 2026</h5>
            </article>
          </div>

          <p>
            I&apos;m a Software Engineering student at <strong>FIAP</strong> and an <strong>Apple Developer Academy</strong> (IPE) member,
            shipping iOS apps with <strong>Swift, SwiftUI, Foundation Models</strong> and <strong>Apple Intelligence</strong>.
          </p>
          <p>
            Outside the App Store I build <strong>AI agents</strong> and <strong>automation pipelines</strong> with
            Claude Code, Replit, Supabase and the Anthropic, OpenAI and Gemini APIs, turning manual workflows into
            multi-agent systems and fast POCs. Two-time <strong>NEXT FIAP finalist</strong>, currently exploring
            Spec-Driven Development and Harness Engineering to scale agent-driven software.
          </p>

          <a href='#contact' className='btn btn-primary'>Get in touch</a>
        </div>
      </div>
    </section>
  );
};

export default About;
